import React from "react";
import PageLayout from "../PageLayout";
import PageSecondLayout from "../PageSecondLayout";
import Process from "./Process";
import PortfolioLink from "./PortfolioLink";
function ServiceHome() {
  return (
    <div>
      <PageLayout
        title="Bringing Your Ideas to Life Through Motion"
        description="We, as Ibex Filmz, are dedicated to crafting compelling narratives that captivate audiences and drive engagement. With our comprehensive suite of services, from storyboard conception to final production, we bring visions to life with precision and creativity. We pride ourselves on our collaborative approach, working hand-in-hand with clients to ensure their message resonates powerfully through every frame."
        videosrc="./video.mp4"
      />
      <PageSecondLayout
        title="A Complete Video Production Company"
        descriptionOne="We are a video production company with a passion & strategic experience to serve and guide our clients at every stage of video production. We dig into the heart of the projects to streamline complex stories and evolve the powerful message in an unforgettable way. Our creative team thrives on transforming visions into compelling narratives, ensuring each video stands out with its unique charm. Collaborating closely with our clients, we craft bespoke video solutions that resonate with audiences and deliver measurable results."
        descriptionTwo="In an era where technology and trends are constantly evolving, we stay at the forefront, integrating the latest innovations in video production to enhance storytelling and engagement. Our approach combines technical excellence with a deep understanding of digital landscapes, enabling us to create content that not only captivates but also achieves strategic objectives. We pride ourselves on building lasting relationships with our clients, becoming their trusted partners in success by consistently exceeding expectations and driving their messages to new heights."
        imgsrc1="./Services/complete/i1.jpg"
        imgsrc2="./Services/complete/i2.jpg"
        imgsrc3="./Services/complete/i3.jpg"
      />
      <PortfolioLink />
      <Process />
      <PageSecondLayout
        title="Pre-production: The Essential Backbone of a Video Production Service"
        descriptionOne="At IBEX FILMZ, we pride ourselves on offering top-tier Pre-Production services tailored to your needs.
        We understand that this phase is pivotal in shaping the final outcome of your project. That's why we
        combine our creative prowess with a structured approach, pouring our heart and soul into every detail."
        descriptionTwo="Our in-house specialized team conducts extensive industry research before delving into concept
        development, ensuring that we align with your objectives and target audience. Expert writers craft engaging scripts that bring your vision to life, while detailed storyboards provide a visual roadmap for
        filming.
        With a structured approach and creative expertise, we prioritize delivering a seamless and comfortable
        experience for our clients, ensuring that your project exceeds expectations from start to finish. We are
        dedicated to bringing your ideas to life in the most impactful and effective way possible."
        imgsrc1="./Services/pre/i1.jpg"
        imgsrc2="./Services/pre/i2.jpg"
        imgsrc3="./Services/pre/i3.jpg"
      />

      {/* <PageThirdLayout
        title="Production"
        descriptionOne="At IBEX FILMZ, we are renowned as the top priority in the media production process, utilizing our
        structured and layered approach to meticulously check every detail before filming begins, saving both
        time and resources. Our skilled team oversees every aspect, from film and video production to direction,
        cinematography, and sound recording. With a focus on detail and creativity, we ensure that every shot
        captures the essence of your project."
        descriptionTwo="Our specialty lies in Corporate Videos, Resort & Real Estate Videos, Documentaries, Destination
        Promotions, Action Sports Videos, Product Commercials and Cinematography. Utilizing top-ofthe-line equipment ranging from high-end cameras & super smooth drone cameras to essential
        accessories, we elevate high-end productions with breathtaking captures. Our background in
        cinematography ensures a unique style characterized by prioritizing framing, composition, and
        storytelling.
        Whether it's capturing stunning visuals or crisp sound, we utilize our passionate & talented crews along
        with equipment collections to ensure your videos capture those unforgettable wow! moments."
        imgsrc="./Services/background.jpg"
      /> */}

<PageSecondLayout
        title="Production"
        descriptionOne="At IBEX FILMZ, we are renowned as the top priority in the media production process, utilizing our
        structured and layered approach to meticulously check every detail before filming begins, saving both
        time and resources. Our skilled team oversees every aspect, from film and video production to direction,
        cinematography, and sound recording. With a focus on detail and creativity, we ensure that every shot
        captures the essence of your project."
        descriptionTwo="Our specialty lies in Corporate Videos, Resort & Real Estate Videos, Documentaries, Destination
        Promotions, Action Sports Videos, Product Commercials and Cinematography. Utilizing top-ofthe-line equipment ranging from high-end cameras & super smooth drone cameras to essential
        accessories, we elevate high-end productions with breathtaking captures. Our background in
        cinematography ensures a unique style characterized by prioritizing framing, composition, and
        storytelling.
        Whether it's capturing stunning visuals or crisp sound, we utilize our passionate & talented crews along
        with equipment collections to ensure your videos capture those unforgettable wow! moments."
        imgsrc1="./Services/7.jpg"
        imgsrc2="./Services/8.jpg"
        imgsrc3="./Services/9.jpg"
      />

      <PageSecondLayout
        title="Post-Production: Refining Your Storytelling"
        descriptionOne="At IBEX FILMZ, our post-production stage is where the magic truly happens, as we refine and polish
        your video to perfection. Our comprehensive post-production services encompass video editing, color
        grading, audio composition, visual effects, dubbing & voiceover, subtitles, and transitions."
        descriptionTwo="Our skilled video editors bring your footage to life, crafting a seamless and engaging narrative that
        captivates your audience. Our audio composition specialists strive to ensure that your videos sound
        nothing short of a Hollywood blockbuster, elevating the auditory experience to match the visual
        spectacle.
        Our meticulous attention to detail on every frame and sound ensures that each video surpasses
        expectations, earning accolades from clients who proclaim, 'You're the best.'"
        imgsrc1="./Services/post/i1.jpg"
        imgsrc2="./Services/post/i2.jpg"
        imgsrc3="./Services/post/i3.jpg"
      />
    </div>
  );
}

export default ServiceHome;
